import { MaybeObservable, MaybeObservableAttributes } from "flow/interfaces/MaybeObservable";
import createRequiredObservable from "flow/koHelpers/createRequiredObservable";
import { interceptAttributesWithDefaultsIgnoreId } from "flow/koHelpers/interceptAttributes";
import { selectIdAttr } from "flow/koHelpers/selectId";
import { selectLabel, selectPlaceholder } from "flow/koHelpers/selectParam";
import createEnabler from "flow/koHelpers/createEnablerDisabler";
import ko from "knockout";
import viewHtml from "./text.html";

export interface ITextParams {
    value: KnockoutObservable<string>;
    enable?: MaybeObservable<boolean>;
    disable?: MaybeObservable<boolean>;
    preventBubble?: string;
    attr?: MaybeObservableAttributes;
    metaPlaceholder?: MaybeObservable<string>;
    placeholder?: MaybeObservable<string>;
    meta?: MaybeObservable<string>;
    text?: MaybeObservable<string>;
}

ko.components.register("ko-text", {
    viewModel: function (params: ITextParams) {
        this.value = params.value;
        this.required = createRequiredObservable(params.value);
        this.id = selectIdAttr("ko_text", params.attr);
        this.label = selectLabel(params.meta, params.text);
        this.enable = createEnabler(params.enable, params.disable);
        this.attributes = interceptAttributesWithDefaultsIgnoreId(
            {
                autocomplete: "off",
                placeholder: selectPlaceholder(params.metaPlaceholder, params.placeholder)
            },
            params.attr
        );
        this.preventBubble = params.preventBubble || "";
    },
    template: viewHtml,
    synchronous: true
});
